import { render, staticRenderFns } from "./order-main.vue?vue&type=template&id=24ec10da&scoped=true&lang=pug&"
import script from "./order-main.vue?vue&type=script&lang=js&"
export * from "./order-main.vue?vue&type=script&lang=js&"
import style0 from "./order-main.vue?vue&type=style&index=0&id=24ec10da&scoped=true&lang=css&"
import style1 from "./order-main.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ec10da",
  null
  
)

export default component.exports